/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Roomannouncementlimit2Inputs */

const en_roomannouncementlimit2 = /** @type {(inputs: Roomannouncementlimit2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.count} announcements for tonight are used up.`)
};

const de_roomannouncementlimit2 = /** @type {(inputs: Roomannouncementlimit2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für heute sind alle ${i?.count} Ankündigungen verschickt.`)
};

/**
* | output |
* | --- |
* | "All {count} announcements for tonight are used up." |
*
* @param {Roomannouncementlimit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementlimit2 = /** @type {((inputs: Roomannouncementlimit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementlimit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementlimit2(inputs)
	return de_roomannouncementlimit2(inputs)
});
export { roomannouncementlimit2 as "roomAnnouncementLimit" }